// extracted by mini-css-extract-plugin
export default {"condensedInfoCard":"hNSs2WJUIt4WTyRSgDCw","paragraphHeader":"eiXdM5BLev91KKA50ZXc","icon":"VqxByMuUBfgG3RKiDiQQ"};